import io from "socket.io-client";
const ngrokLink =
  "https://0415-2407-d000-1a-d56e-5914-aa3c-5ac0-8e90.ngrok-free.app";
// const renderLink = "https://lawvocate-python.onrender.com";

const renderLink = "https://lawvocate-backend.onrender.com";

export const socketInstance = io(`${renderLink}`);
